import { render } from "./DialogTitle.vue?vue&type=template&id=71cdd902&ts=true"
import script from "./DialogTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogTitle.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/dialog/DialogTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71cdd902"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71cdd902', __exports__)) {
    api.reload('71cdd902', __exports__)
  }
  
  module.hot.accept("./DialogTitle.vue?vue&type=template&id=71cdd902&ts=true", () => {
    api.rerender('71cdd902', render)
  })

}


export default __exports__